import { useState } from 'react';
import { verifyTripAccess } from '../lib/api';
import { setTripAccess } from '../lib/tripAccess';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Lock } from '@phosphor-icons/react';
import EventBranding from '../components/EventBranding';

export default function TripPasswordGate({ code, brandingImageUrl, coverImageUrl, onUnlock }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) return;
    setLoading(true);
    setError('');
    try {
      const { data } = await verifyTripAccess(code, password.trim());
      setTripAccess(code, data.role, password.trim(), data.legacy);
      onUnlock(data.role, data.legacy);
    } catch (err) {
      setError(err.response?.data?.detail || 'Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F6F5] flex items-center justify-center px-4" data-testid="trip-password-gate">
      <div className="w-full max-w-sm bg-white rounded-2xl border border-[#E1E6E4] p-6 space-y-5">
        <EventBranding imageUrl={brandingImageUrl} eager />
        <div className="flex flex-col items-center gap-2">
          <div className="w-12 h-12 rounded-full bg-[#1B4332]/10 flex items-center justify-center">
            <Lock className="w-6 h-6 text-[#1B4332]" weight="bold" />
          </div>
          <h2 className="text-lg font-bold text-[#1D242B]">Enter Trip Password</h2>
          <p className="text-sm text-[#455561] text-center">Enter your organiser or player code to continue.</p>
          <p className="text-xs text-[#8A9BA8] font-mono">Event Code: {code}</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-3">
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(''); }}
            className="h-12 rounded-xl text-base"
            autoFocus
            data-testid="trip-password-input"
          />
          {error && <p className="text-sm text-red-600 text-center" data-testid="trip-password-error">{error}</p>}
          <Button type="submit" disabled={loading || !password.trim()}
            className="w-full h-12 rounded-xl bg-[#1B4332] hover:bg-[#163B2B] text-white font-semibold"
            data-testid="trip-password-submit">
            {loading ? 'Verifying...' : 'Continue'}
          </Button>
        </form>
      </div>
    </div>
  );
}
